var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"idModalHistoryCarrier","size":"xl","hide-footer":"","centered":"","title":"Historial Carrier"}},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items,"fields":_vm.fields,"small":true,"fixed":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }